import { useState, useEffect } from 'react';
import { useAuth } from '../modules/auth/hooks/useAuth';
import { fetchOrganization } from '../modules/auth/services/organization.service';

export function SidebarTenant() {
  const { user } = useAuth();
  const organizationId = user?.organizationId ?? null;
  const [orgName, setOrgName] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!organizationId) {
      setLoaded(true);
      return;
    }
    fetchOrganization(organizationId)
      .then((org) => setOrgName(org.name))
      .catch(() => setOrgName(null))
      .finally(() => setLoaded(true));
  }, [organizationId]);

  if (!loaded) return null;

  return (
    <div className="mx-2 mb-2 flex items-center gap-3 rounded-md bg-gray-800 px-3 py-3">
      <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-md bg-gray-700">
        <svg className="h-4 w-4 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      </div>
      {orgName
        ? <span className="truncate text-sm font-medium text-white">{orgName}</span>
        : <span className="truncate text-sm text-gray-400">組織未設定</span>
      }
    </div>
  );
}
